import { AuthProvider } from "react-admin";
import { getKeycloak } from "./keycloak";

const isExternalRoute = () => window.location.hash.startsWith("#/externals");

const safeGetKeycloak = () => {
  try {
    return getKeycloak();
  } catch (e) {
    return null;
  }
};

const authProvider: AuthProvider = {
  // no real login on the RA side (Keycloak handles it)
  login: () => Promise.resolve(),

  checkAuth: () => {
    // 1) external roads are public
    if (isExternalRoute()) {
      return Promise.resolve();
    }

    // 2) the rest must be protected
    const kc = safeGetKeycloak();
    if (kc && kc.authenticated) {
      return Promise.resolve();
    }

    return Promise.reject({ redirectTo: window.location.origin });
  },

  checkError: ({ status }) =>
    status === 401 || status === 403 ? Promise.reject() : Promise.resolve(),

  getPermissions: () => {
    // For externals, no roles → that's okay
    if (isExternalRoute()) {
      return Promise.resolve([]);
    }
    const kc = safeGetKeycloak();
    const roles = kc?.tokenParsed?.realm_access?.roles ?? [];
    return Promise.resolve(roles);
  },

  logout: () => {
    // If we are on the external network, we do not attempt to call KC.
    if (isExternalRoute()) {
      return Promise.resolve();
    }

    const kc = safeGetKeycloak();
    if (kc) {
      kc.logout();
    }
    localStorage.removeItem("kc_token");
    localStorage.removeItem("kc_refreshToken");
    return Promise.resolve();
  },

  getIdentity: () => {
    // on the external server, we return a “fake” user
    if (isExternalRoute()) {
      return Promise.resolve({
        id: "external",
        fullName: "Invité externe",
      });
    }

    const kc = safeGetKeycloak();
    if (!kc) {
      // very rare case: KC not ready
      return Promise.resolve({
        id: "anonymous",
        fullName: "Anonymous",
      });
    }

    const profile = kc.tokenParsed as any;
    return Promise.resolve({
      id: profile.sub,
      fullName: profile.preferred_username,
    });
  },
};

export default authProvider;
